module.exports = __webpack_public_path__ + "static/media/S (176).46b67f01.jpg";